import PropTypes from 'prop-types';

import { useTransl } from 'shared/lib/i18n';

import { isAdmin, isPM } from '../../utils';

import AccessCardRouter from '../../routes/AccessCardRouter';
import Route from '../../routes/SentryRoute';
import TabsComponentWithLinks from '../Tabs/TabsComponentWithLinks';

const AccessCard = (props) => {
  const { t } = useTransl();
  const { match, location } = props;
  if (!isAdmin() && !isPM(match?.params, true)) {
    return null;
  }
  const tabData = [
    {
      label: t('title.accessCards'),
      url: `${match.url}/list`,
    },
    {
      label: t('title.accessCardBatches'),
      url: `${match.url}/batches-list`,
    },
  ];
  return (
    <>
      <TabsComponentWithLinks
        tabData={tabData}
        currentUrl={location.pathname}
      />
      <Route path="/">
        <AccessCardRouter {...props} />
      </Route>
    </>
  );
};

AccessCard.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  location: PropTypes.instanceOf(Object).isRequired,
};

export default AccessCard;
